import { createAsyncThunk } from '@reduxjs/toolkit';
import masterApi from '~/apis/master';
import { GET_MASTER_DATA } from '~/utils/constants/actionType';
import { IParamsGetMasterData, IResponseGetMasterData } from '~/utils/interface/master';

export const handleGetMasterData = createAsyncThunk<IResponseGetMasterData, IParamsGetMasterData>(
  GET_MASTER_DATA,
  async (params: IParamsGetMasterData, { rejectWithValue }) => {
    try {
      const res = await masterApi.getMasterData(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
